import useNoticeQuery from "features/notice/hooks/queries/useNoticeQuery";
import { useParams } from "react-router-dom";
import "@toast-ui/editor/dist/toastui-editor-viewer.css";
import useMediaView from "features/common/hooks/useMediaView";
import NoticeDashboardDetailMobilePage from "./(mobile)/NoticeDashboardDetailMobilePage";
import NoticeDashboardDetailWebPage from "./(web)/NoticeDashboardDetailWebPage";
import React from "react";

const NoticeDashboardDetailPage = () => {
  const isSmall = useMediaView("small");
  const { id } = useParams<{ id: string }>();
  const { data } = useNoticeQuery(id as string);

  const notice = data.data.result.notice;

  return (
    <>
      {isSmall ? (
        <NoticeDashboardDetailMobilePage noticeDetail={notice} />
      ) : (
        <NoticeDashboardDetailWebPage noticeDetail={notice} />
      )}
    </>
  );
};

export default NoticeDashboardDetailPage;
